export const OPEN_CRITERIA_TRANSPORT_EVENT = 'openCriteriaTransport';
